import { mockComplianceList } from '../../__mocks__/settings/settingsComplianceListMock';
import { mockComplianceDetails } from '../../__mocks__/settings/settingsComplianceDetailsMock';
import { createHttpService } from '../ApiService';
import { normalizePaginatedResponse } from '../__shared/paginationUtils';
import { TPaginationParams } from '../__shared/shared.interfaces';
import { ComplianceListApiResponse } from './settings.Interfaces';
import { ComplianceListItem } from './settingsComplianceListItem.interfaces';
import { ComplianceItem } from './settingsComplianceItem.interfaces';
import isAppWithMock from 'src/utils/isAppWithMock';

export const useSettingsService = () => {
  const httpAPI = createHttpService();
  const baseSettingsPath = '/settings';
  const withMockData = isAppWithMock();
  const subBaseEndPoint = '/compliance';

  const getComplianceList = (
    _params: TPaginationParams
  ): Promise<ComplianceListApiResponse> => {
    if (withMockData) {
      return Promise.resolve(
        normalizePaginatedResponse(
          {
            data: mockComplianceList,
            count: mockComplianceList.length,
            page: 1,
            limit: 10,
          },
          'data'
        )
      );
    }

    const requestObj = {
      params: {
        page: Number(_params.page) || 1,
        limit: Number(_params.limit) || 10,
      },
    };

    return httpAPI
      .get<any>(`${baseSettingsPath}${subBaseEndPoint}`, requestObj)
      .then((res) => {
        const body = res?.data ?? res;
        if (body && (Array.isArray(body.data) || body.data === undefined)) {
          return normalizePaginatedResponse<ComplianceListItem>(body, 'data');
        }
        return normalizePaginatedResponse<ComplianceListItem>({}, 'data');
      })
      .catch(() =>
        normalizePaginatedResponse<ComplianceListItem>(
          { data: [], count: 0, page: 1, limit: 10 },
          'data'
        )
      );
  };

  const getComplianceDetails = (id: string): Promise<ComplianceItem | null> => {
    if (withMockData) {
      return Promise.resolve(mockComplianceDetails);
    }
    return httpAPI
      .get<ComplianceItem | null>(`${baseSettingsPath}${subBaseEndPoint}/${id}`)
      .then((response) => response as ComplianceItem)
      .catch((error) => {
        return null;
      });
  };

  return {
    getComplianceList,
    getComplianceDetails,
  };
};
